// @flow
// $FlowFixMe - Cannot import useEffect because there is no useEffect export in react.
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import NotificationMessage from '../NotificationMessage';
import { inputStyle } from './inputStyles';

export const TextareaHookFormLayout = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 4px;
`;

const Textarea = styled.textarea`
  ${inputStyle};
  padding: 11px;
  resize: vertical;
  min-height: 40px;
`;

type TextareaHookFormProps = {
  'aria-label': string,
  defaultValue?: ?string | boolean | number,
  disabled?: boolean,
  name: string,
  rules?: ?any,
};

const TextareaHookForm = ({
  defaultValue,
  disabled,
  name,
  rules,
  ...props
}: TextareaHookFormProps) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    setValue(name, defaultValue || null);
  }, [defaultValue, name, setValue]);

  const errorText = errors?.[name]?.message;

  return (
    <TextareaHookFormLayout>
      <Textarea
        {...register(name, rules)}
        defaultValue={defaultValue}
        disabled={disabled}
        errorText={errorText}
        name={name}
        {...props}
      />
      {errorText && <NotificationMessage styleType="error">{errorText}</NotificationMessage>}
    </TextareaHookFormLayout>
  );
};

TextareaHookForm.defaultProps = {
  defaultValue: undefined,
  disabled: false,
  rules: undefined,
};

export default TextareaHookForm;
